var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{staticClass:"full-height full-width d-flex flex-column align-center justify-center pa-4"},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.label)))]),_c('v-progress-linear',{attrs:{"indeterminate":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }